import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import MasterCheckoutShippingReducer from "@MasterBluePrint/Pages/CheckoutShipping/MasterCheckoutShippingReducer";
import MasterCheckoutShippingState from "@MasterBluePrint/Pages/CheckoutShipping/MasterCheckoutShippingState";
import RequestQuoteModalReducer from "@MasterBluePrint/Store/Components/RequestQuoteModal/RequestQuoteModalReducer";
import RequestQuoteModalState from "@MasterBluePrint/Store/Components/RequestQuoteModal/RequestQuoteModalState";

export type MasterState = {
    requestQuoteModal: RequestQuoteModalState;
    masterCheckoutShipping: MasterCheckoutShippingState;
} & ApplicationState;

(reducers as any).requestQuoteModal = RequestQuoteModalReducer;
(reducers as any).masterCheckoutShipping = MasterCheckoutShippingReducer;

type MasterReducers = typeof reducers;

export type MasterActions = AnyAction | Parameters<MasterReducers[keyof MasterReducers]>[1];